import { createSlice } from '@reduxjs/toolkit';
import {
    GET_PROJECTS,
    GET_PROJECTS_SUCCESS,
    GET_PROJECTS_FAIL,
    GET_PROJECT,
    GET_PROJECT_SUCCESS,
    GET_PROJECT_FAIL,
} from '../../constants/actions/project.constants';

const NAME = 'surveyLoading';

type LoadingState = { isLoading: boolean; isLoaded: boolean };

const initialLoading: LoadingState = { isLoading: false, isLoaded: false };

export type SurveyLoadingState = {
    projects: LoadingState;
    project: LoadingState;
};

const initialState: SurveyLoadingState = {
    projects: initialLoading,
    project: initialLoading,
};

const slice = createSlice({
    name: NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GET_PROJECTS, (state) => {
                state.projects = { ...state.projects, isLoading: true };
            })
            .addCase(GET_PROJECTS_SUCCESS, (state) => {
                state.projects = { isLoading: false, isLoaded: true };
            })
            .addCase(GET_PROJECTS_FAIL, (state) => {
                state.projects = { ...state.projects, isLoading: false };
            })
            .addCase(GET_PROJECT, (state) => {
                state.project = { ...state.project, isLoading: true };
            })
            .addCase(GET_PROJECT_SUCCESS, (state) => {
                state.project = { isLoading: false, isLoaded: true };
            })
            .addCase(GET_PROJECT_FAIL, (state) => {
                state.project = { ...state.project, isLoading: false };
            });
    },
});

export default { reducer: slice.reducer, actions: slice.actions };
